import {enConfig} from './en';

export const esConfig = {
    ...enConfig.base,
    bismi:'En el nombre de Dios, el Compasivo, el Misericordioso.',
    salaam:'Salaam',
    header:{
        signup : "Inscripción",
        signin : "Conexión",    
        signout : "Salida",
        close: "Cerrar",
        profile: "Perfil",
        email: "Correo",
        phone: "Teléfono",
        about : "Acerca de",
        article : "Artículos",
        contact : "Contacto",
        download: "Descargar",
        joinus : "Únete a nos"
    },
    
    home:{
        title : 'Digitalización',
        about: 'Nosotros apuntamos a introducir a la nueva generación a las profesiones digitales y lenguajes de programación, particularmente Python y Js',
        connected: 'Debe estar registrado'
    },

    profile:{
        salaam :'Hola, ',
        setting:'Ajustes',
        contact:'Contacto',
        logout:'Cerrar sesión',
        site:'Sitio',
        profile:'Perfil',
        home:'Casa',
        contact:'Contacto',
        order:'Orden',
        invoice:'Facturas',
    },
    
    profile:{
        salaam :'你好, ',
        setting:'设置',
        contact:'联系',
        logout:'登出',
        site:'网站',
        profile:'个人资料',
        home:'主页',
        contact:'联系',
        order:'订单',
        invoice:'发票',
    },

    plan:{
        ...enConfig.plan,
        title :'订阅与计划',
        order :'立即订购',
        extend : '获得更多容量',
        Extend : '扩展计划',
        credit : '他有信用'
    },

    blog: {
        ...enConfig.blog,
        title :'Artículos más interesantes',
    },

    contact:{
        title:'Contáctenos',
        message:'Complete el siguiente formulario para enviarnos un correo electrónico',
        confirm:'Confirmación de contacto',
        content:'Complete el código que le enviamos por correo electrónico para confirmarlo',
        recipient:"Confirme la información del destinatario.",
        feedback : 'Hemos recibido su mensaje, nos pondremos en contacto con usted lo antes posible',
        warning : "Necesita confirmar su correo electrónico antes de continuar"
    },

    getApp : {
        name : 'Descargar Services App',
        info : 'Descargar Services App'
    },

}
